import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Trash2Icon } from "lucide-react";
import { AddMemberDialog } from "./AddMemberDialog";

interface Member {
  id: string;
  role: string;
  profile: {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    avatar_url?: string | null;
  };
}

interface MembersListProps {
  members: Member[];
  onAddMember: (email: string) => void;
  onRemoveMember: (memberId: string) => void;
}

export const MembersList = ({ members, onAddMember, onRemoveMember }: MembersListProps) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
        <CardTitle>Miembros</CardTitle>
        <AddMemberDialog onAddMember={onAddMember} />
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {members.map((member) => (
            <div key={member.id} className="flex items-center space-x-4">
              <div className="flex items-center space-x-4 flex-1 min-w-0">
                <Avatar>
                  <AvatarImage
                    src={
                      member.profile?.avatar_url ||
                      `https://api.dicebear.com/7.x/avataaars/svg?seed=${member.profile?.email}`
                    }
                  />
                  <AvatarFallback>
                    {member.profile?.first_name?.[0]?.toUpperCase() ||
                      member.profile?.email?.[0]?.toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="min-w-0">
                  <p className="text-base font-medium truncate">
                    {member.profile?.first_name
                      ? `${member.profile.first_name} ${member.profile.last_name || ""}`
                      : member.profile?.email}
                  </p>
                  <p className="text-base text-muted-foreground capitalize">
                    {member.role === "owner" ? "Propietario" : "Arrendatario"}
                  </p>
                  <p className="text-base text-muted-foreground truncate">{member.profile?.email}</p>
                </div>
              </div>
              {member.role !== "owner" && (
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-destructive hover:text-destructive hover:bg-destructive/10 flex-shrink-0"
                  onClick={() => onRemoveMember(member.id)}
                >
                  <Trash2Icon className="h-4 w-4" />
                </Button>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};